import React, { ReactElement } from 'react';

interface ActionButtonProps {
    title: string;
    onClick?: () => void;
    icon?: ReactElement;
    type: string;
}
export default function ActionButton({ title, onClick, icon, type }: ActionButtonProps) {
    return (
        <>
            {type === 'simple' && (
                <button
                    className={`Vizor__Button flex flex--all-center transition0`}
                    onClick={onClick}
                >
                    {title} {icon}
                </button>
            )}

            {type === 'disable' && (
                <button
                    className={`Vizor__Button Vizor__Button--disabled flex flex--all-center transition`}
                    onClick={onClick}
                >
                    {title} {icon}
                </button>
            )}

            {type === 'close' && (
                <button
                    className={`Vizor__Button Vizor__Button--close flex flex--all-center transition`}
                    onClick={onClick}
                >
                    {title} {icon}
                </button>
            )}

            {type === 'only-text' && (
                <button
                    className={`Vizor__Button Vizor__Button--only-text flex flex--all-center transition`}
                    onClick={onClick}
                >
                    {icon} {title}
                </button>
            )}

            {type === 'link-table' && (
                <button
                    className={`Vizor__Button Vizor__Button--link-table  flex flex--all-center transition`}
                    onClick={onClick}
                >
                    {icon} {title}
                </button>
            )}
        </>
    );
}
